module.exports = __webpack_public_path__ + "img/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.60a38c82.webp";